import ReportPage from "../../components/ReportPage";
import { downloadDistributionDetail } from "../../API";

const schema = {
  title: "Stores Not Selling Report",
  params: [
    { name: "banners", label: "Banner", type: "multiselect", route: "banners", payloadKey: "bannerIds", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: false,
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        const statusSearch = status === "ALL" ? "" : `,status:${status}`;
        return `?search=manufacturer:${manufacturer.id}${statusSearch}&size=1000`;
      },
    },
  ],
  downloadFn: downloadDistributionDetail,
};

export default function DistributionDetailReport() {
  return <ReportPage schema={schema} />;
}
